import _ from 'underscore';

export function extract(adGroup, errors, errorList, subEntity, canEdit) {
  if (_.isArray(adGroup[subEntity])) {
    _.each(adGroup[subEntity], (item) => {
      if (item['Client Id'] && (canEdit || (!canEdit && !item.Id))) {
        const errorsOfThisItem = _.where(errors.errors, { 'Client Id': item['Client Id'] });

        Array.prototype.push.apply(errorList, errorsOfThisItem);
      }
    });
  }
}
